import LandingLayout from './LandingLayout';

export const CurrentLandingLayout = LandingLayout;
